import type { Design } from "./design";

// A single response carries every changed element and the complete layer order.
// Membership in elementOrder also describes removals, including descendants.
export type DesignChanges = Design & { baseRevision: number; elementOrder: string[] };

export function applyDesignChanges(current: Design, changes: DesignChanges, historical = false): Design {
  if (current.id !== changes.id || current.revision !== changes.baseRevision || (!historical && changes.revision < current.revision))
    throw new Error("The canvas synchronization base changed.");
  const byId = new Map(current.elements.map((element) => [element.id, element]));
  for (const element of changes.elements) byId.set(element.id, element);
  const { baseRevision: _, elementOrder, ...metadata } = changes;
  return { ...metadata, elements: elementOrder.map((id) => {
    const element = byId.get(id);
    if (!element) throw new Error("Incomplete canvas synchronization.");
    return element;
  }) };
}
